import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import PortfolioPage from '../../pages/user/PortfolioPage';

const SlugRedirect = () => {
  const { slug } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [portfolioExists, setPortfolioExists] = useState(false);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const checkSlug = async () => {
      try {
        // 포트폴리오 테이블에서 해당 슬러그가 존재하는지 확인
        const { data, error } = await supabase
          .from('portfolios')
          .select('slug')
          .eq('slug', slug)
          .eq('status', 'published')
          .maybeSingle();

        if (error) {
          console.error('Error checking slug:', error);
          setNotFound(true);
        } else if (data) {
          // 포트폴리오가 존재하면 직접 렌더링 (리다이렉트 없음)
          setPortfolioExists(true);
        } else {
          // 포트폴리오가 아니면 404 처리
          setNotFound(true);
        }
      } catch (err) {
        console.error('Unexpected error:', err);
        setNotFound(true);
      } finally {
        setIsLoading(false);
      }
    };

    if (slug) {
      checkSlug();
    } else {
      setNotFound(true);
      setIsLoading(false);
    }
  }, [slug]);

  // 로딩 중
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-4"></div>
          <p className="text-lg text-gray-600">페이지를 확인하고 있습니다...</p>
        </div>
      </div>
    );
  }

  // 포트폴리오인 경우 직접 렌더링 (리다이렉트 없음)
  if (portfolioExists) {
    return <PortfolioPage />;
  }

  // 포트폴리오가 아닌 경우 404 페이지
  if (notFound) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-8">
          <div className="mb-4">
            <svg className="mx-auto h-16 w-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">페이지를 찾을 수 없습니다</h2>
          <p className="text-gray-600 mb-6">
            요청하신 페이지 "/{slug}"가 존재하지 않습니다.
          </p>
          <a 
            href="/"
            className="inline-block px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            홈으로 돌아가기
          </a>
        </div>
      </div>
    );
  }

  return null;
};

export default SlugRedirect;
